export default "__VITE_ASSET__Di2bv4YI__"